export default __webpack_public_path__ + "static/media/task_book_appointment_icon.1bea0560.svg";